import React from 'react';

import Block from './Block';
import HBlocks from './HBlocks';
import Title from './Title';

export function Infographic({noTitle = false, type = null}) {
    return (
        <div className={'loading--infographic'}>
            {noTitle || <Title type={type} />}
            <Title type={type} subTitle />
            <HBlocks count={3} size={'sm'} />
            <Title type={type} subTitle />
            <Block size={'mlg'} />
            <Title type={type} subTitle />
            <HBlocks count={2} size={'sm'} />
            <HBlocks count={2} size={'sm'} />
        </div>
    );
}

export default Infographic;
